import React, { createContext, useContext, useMemo } from 'react';

import { getStatsigExperimentConfig } from '../services/statsig';

import { type ExperimentConfig, type ExperimentContextProps } from './types';

const Context = createContext<ExperimentConfig>(undefined);

export const ExperimentContext = ({ children }: ExperimentContextProps) => {
	const config = useMemo(() => getStatsigExperimentConfig(), []);

	return <Context.Provider value={config}>{children}</Context.Provider>;
};

export const useExperimentContext = () => {
	return useContext(Context);
};
